/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemAggregationValueSchema } from './itemAggregationValueSchema';

export const numericSchema = z
  .lazy(() => itemAggregationValueSchema)
  .and(
    z.object({
      value: z.number().nullish(),
    }),
  );
